import useBranchImageHook from "@/shared/hooks/useBranchImageHook";
import { BranchGroup } from "@/shared/utils/interfaces";
import Icon from "../Icon/Icon";

const OrderCardBranchImage = ({
  branchGroup,
}: {
  branchGroup: BranchGroup;
}) => {
  const { url, isPending } = useBranchImageHook(branchGroup.branch.id);
  return (
    <div>
      {isPending || (!isPending && url.includes("undefined")) ? (
        <Icon className="h-16 w-16" variants="appsmen" />
      ) : (
        <img src={url} className="object-contain w-16 block" />
      )}
    </div>
  );
};

export default OrderCardBranchImage;
